import type { ThemeConfig } from 'antd';

const FONT_FAMILY = '"Open Sans", sans-serif';

const WHITE = '#ffffff';
const MENU_BG_COLOR = '#222';
const MENU_ITEM_BG_COLOR_ON_HOVER = '#3D3D3D';
const MENU_ITEM_BG_COLOR_ON_SELECTED = '#1890ff';
const SUB_MENU_BG_COLOR = '#141414';

export const antdTheme: ThemeConfig = {
  components: {
    Avatar: {
      fontSize: 12,
    },
    Layout: {
      siderBg: MENU_BG_COLOR,
    },
    Menu: {
      darkItemBg: MENU_BG_COLOR,
      darkItemHoverBg: MENU_ITEM_BG_COLOR_ON_HOVER,
      darkItemHoverColor: WHITE,
      darkItemSelectedBg: MENU_ITEM_BG_COLOR_ON_SELECTED,
      darkItemSelectedColor: WHITE,
      darkSubMenuItemBg: SUB_MENU_BG_COLOR,
    },
    Table: {
      cellFontSize: 14,
      fontFamily: FONT_FAMILY,
    },
  },
  token: {
    borderRadius: 4,
    colorBgContainer: WHITE,
    colorBorder: '#d9d9d9',
    colorInfo: '#228be6',
    colorPrimary: '#228be6',
    colorText: '#434343',
    colorTextHeading: '#000000',
    fontFamily: FONT_FAMILY,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    paddingLG: 24,
  },
};
